import { render, staticRenderFns } from "./SearchBarGlobal.vue?vue&type=template&id=2a326899&class=global-search"
import script from "./SearchBarGlobal.vue?vue&type=script&lang=js"
export * from "./SearchBarGlobal.vue?vue&type=script&lang=js"
import style0 from "./SearchBarGlobal.vue?vue&type=style&index=0&id=2a326899&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports